import React, { useState, useEffect, useRef } from 'react';
import {
  getComponentsByType,
  getDataByType,
  getSystemBannerBackgroundConfig,
  isBannerConfigDefault,
} from '../../../utils/utils';
import { SystemInfoHeader } from '../../organisms/system/systemInfoHeader/SystemInfoHeader';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import { Breadcrumbs } from '../../molecules/shared/breadcrumbs/Breadcrumbs';
import { InfoCards } from '../../organisms/system/infoCards/InfoCards';
import { Media } from '../../organisms/system/media/Media';
import PopularCategories from '../../organisms/shared/popularCategories/PopularCategories';
import SystemRightForMe from '../../organisms/system/systemRightForMe/SystemRightForMe';
import AboutSystem from '../../organisms/system/aboutSystem/AboutSystem';
import ShortcutsBar from '../../organisms/system/shortcutsBar/ShortcutsBar';
import InfoSection from '../../organisms/system/infoSection/InfoSection';
import AccordionSection from '../../organisms/system/accordionSection/AccordionSection';
// import Alternatives from '../../organisms/system/alternatives/Alternatives';
import CompareSystems from '../../organisms/system/compareSystems/CompareSystems';
import Reviews from '../../organisms/system/reviews/Reviews';
import Footer from '../../organisms/shared/footer/Footer';
import Header from '../../organisms/shared/header/Header';
import ServiceRequestModal from '../../organisms/system/serviceRequestModal/ServiceRequestModal';
import colors from '../../../../tailwind.colors';
import ModalContainer from '../../molecules/shared/modalV2/ModalContainer';
import SystemBanner from '../../organisms/system/systemBanner/SystemBanner';

export const System = ({
  isPaid,
  sections,
  // hero,
  breadcrumbs,
  t,
  locale,
  menu,
  footer,
  siteUrls,
  location,
  search,
  handleDataLayer,
  trackOutboundLink,
  preview = false,
}) => {
  // helper states
  const yOffset = -200;
  const [scrollPosition, setScrollPosition] = useState(1);
  const [initialPosition, setInitialPosition] = useState(null);
  const [shorcutPressed, setIsShortcutPressed] = useState(false);
  const [modalOpenInquiry, setModalOpenInquiry] = useState(false);
  const [modalOpenReview, setModalOpenReview] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const shortcutsRef = useRef(null);
  const infoSectionRef = useRef(null);
  const reviewsSectionRef = useRef(null);
  const accordionSectionRef = useRef(null);
  // const alternativesRef = useRef(null);
  const compareRef = useRef(null);

  // data
  const headerSection = getDataByType(sections, 'header');
  const infoData = getDataByType(sections, 'infoSection');
  const mediaSection = getDataByType(sections, 'media');
  const infoCardSection = getDataByType(sections, 'sectionUSP');
  const reviewsData = getComponentsByType(sections, 'reviews');
  const popularSection = getDataByType(sections, 'popularCategories');
  const accordionData = getDataByType(sections, 'accordionSection');
  const systemRightForMe = getDataByType(sections, 'systemRightForMe');
  // const alternatives = getDataByType(sections, 'alternatives');
  const doYouKnow = getDataByType(sections, 'doYouKnow');
  const companyCheck = getDataByType(sections, 'companyCheck');
  const aboutSection = getDataByType(sections, 'aboutSection');
  const compareSection = getDataByType(sections, 'compare');
  const serviceRequestData = getDataByType(sections, 'serviceRequestFormData');
  const writeReviewData = getDataByType(sections, 'writeReviewData');

  const { companyName, systemName, category } = headerSection.componentData;

  const buttonTitles = [
    {
      title: t('sp.whyChooseCompany', { companyName }),
      href: `${location?.pathname}#why`,
      disabled: preview,
    },
    {
      title: t('sp.reviews'),
      href: `${location?.pathname}#reviews`,
      disabled: preview,
    },
    {
      title: t('sp.functions'),
      href: `${location?.pathname}#functions`,
      disabled: preview,
    },
    {
      title: t('sp.alternative'),
      href: headerSection.componentData.alternativesUrl,
      link: true,
      disabled: preview,
    },
  ];
  const buttonTitlesUnpaid = [
    {
      title: t('sp.reviews'),
      href: `${location?.pathname}#reviews`,
      disabled: preview,
    },
    {
      title: t('sp.functions'),
      href: `${location?.pathname}#functions`,
      disabled: preview,
    },
    {
      title: t('sp.comparisons'),
      href: `${location?.pathname}#comparisons`,
      disabled: preview,
    },
    {
      title: t('sp.alternative'),
      href: headerSection.componentData.alternativesUrl,
      link: true,
      disabled: preview,
    },
  ];

  // TODO: Is a bug in this function. If scrolled down, then reload page, then it get messed up...
  const handleScroll = () => {
    const navBarHeight = document.getElementById('navbar').offsetHeight;
    const scrollTop = window.scrollY;

    const reviewsScroll = (reviewsSectionRef?.current?.offsetTop || 0) - 300;
    const accordionScroll = (accordionSectionRef.current?.offsetTop || 0) - 300;
    const compareScroll = (compareRef.current?.offsetTop || 0) - 300;

    let newPosition = 1;

    if (isPaid) {
      if (scrollTop > 0 && scrollTop < reviewsScroll) {
        newPosition = 1;
      } else if (scrollTop >= reviewsScroll && scrollTop < accordionScroll) {
        newPosition = 2;
      } else if (scrollTop >= accordionScroll) {
        newPosition = 3;
      }
    } else if (scrollTop > 0 && scrollTop < accordionScroll) {
      newPosition = 1;
    } else if (scrollTop >= accordionScroll && scrollTop < compareScroll) {
      newPosition = 2;
    } else if (scrollTop >= compareScroll) {
      newPosition = 3;
    }

    setScrollPosition(newPosition);
    if (initialPosition && scrollTop >= initialPosition - navBarHeight) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  };

  useEffect(() => {
    handleScroll();
  }, []);

  useEffect(() => {
    if (modalOpenInquiry || modalOpenReview) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [modalOpenInquiry, modalOpenReview]);

  const openModalFormInquiry = () => {
    setModalOpenInquiry(true);
  };

  const openModalFormReview = () => {
    setModalOpenReview(true);
  };

  const closeModalForm = () => {
    setModalOpenInquiry(false);
    setModalOpenReview(false);
  };

  useEffect(() => {
    const shortcutsDiv = shortcutsRef.current.getBoundingClientRect();
    setInitialPosition(shortcutsDiv?.top || 0);

    // TODO: Add fn for check if window is resized

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [initialPosition, isPaid]);

  const scrollToSection = (id) => {
    let targetPosition = 0;
    if (isPaid) {
      switch (id) {
        case 1:
          targetPosition = infoSectionRef.current.offsetTop + yOffset;
          break;
        case 2:
          targetPosition = reviewsSectionRef.current.offsetTop + yOffset;
          break;
        case 3:
          targetPosition = accordionSectionRef.current.offsetTop + yOffset;
          break;
        default:
          break;
      }
    } else {
      switch (id) {
        case 1:
          targetPosition = reviewsSectionRef.current.offsetTop + yOffset;
          break;
        case 2:
          targetPosition = accordionSectionRef.current.offsetTop + yOffset;
          break;
        case 3:
          targetPosition = compareRef.current.offsetTop + yOffset;
          break;
        default:
          break;
      }
    }
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  };

  const hashScrollHandler = (hash) => {
    let index = 0;
    if (isPaid) {
      index = buttonTitles.findIndex((el) => el.href.includes(hash));
    } else index = buttonTitlesUnpaid.findIndex((el) => el.href.includes(hash));
    scrollToSection(index + 1);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (window.location.hash && window.location.hash.length > 0) {
        hashScrollHandler(window.location.hash);
      }
    }, 300);
    return () => {
      clearTimeout(timeout);
    };
  }, [shorcutPressed]);

  const isBannerAllowed = !!headerSection?.componentData?.hasBanner;

  return (
    <div className="bg-white overflow-x-hidden">
      <NavigationBar
        isTransparent={isBannerAllowed}
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
        preview={preview}
      />
      <Header show={!isBannerAllowed} minimized />
      <main className="relative">
        <div className="relative">
          <div
            style={getSystemBannerBackgroundConfig(
              isBannerAllowed,
              headerSection
            )}
          >
            {isBannerConfigDefault(isBannerAllowed, headerSection) && (
              <div className="absolute bg-[rgba(255,255,255,0.62)] inset-0 z-1" />
            )}
            <div
              className={
                isBannerAllowed
                  ? 'flex w-full flex-col flex-1 lg:mx-auto relative bottom-2 max-md:pt-[80px] md:pt-[120px]'
                  : ''
              }
            >
              <SystemBanner
                show={isBannerAllowed}
                className="relative top-10 rounded-[32px] max-md:rounded-b-none"
                // TODO Should have a fixed height so we don't have layout shift
                headerSection={headerSection}
              />
              <SystemInfoHeader
                className={
                  isBannerAllowed &&
                  'shadow-xl bg-white rounded-[32px] max-md:rounded-t-none max-lg:p-5 relative bottom-[60px] max-md:bottom-0 z-1 pr-5'
                }
                section={headerSection}
                isPaid={isPaid}
                openModalForm={openModalFormReview}
                t={t}
                trackOutboundLink={trackOutboundLink}
              />
            </div>
          </div>
        </div>
        <div className={`h-auto w-full bg-primary-50 ${isFixed && 'pt-16'}`}>
          <ShortcutsBar
            shortcutsRef={shortcutsRef}
            fixed={isFixed}
            scrollPosition={scrollPosition}
            buttonTitles={isPaid ? buttonTitles : buttonTitlesUnpaid}
            onPress={() => setIsShortcutPressed(!shorcutPressed)}
          />
          <Breadcrumbs levels={breadcrumbs} infoText={t('legal.system.text')} />
          <InfoSection
            ref={infoSectionRef}
            section={infoData}
            isPaid={isPaid}
            openModalForm={openModalFormInquiry}
            t={t}
            handleDataLayer={handleDataLayer}
          />
          {isPaid && (
            <>
              <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto my-20 max-w-7xl">
                {mediaSection.componentData.length > 0 && (
                  <Media
                    systemName={systemName}
                    category={category}
                    media={mediaSection.componentData}
                    handleDataLayer={handleDataLayer}
                  />
                )}
              </div>
              {infoCardSection.componentData.length > 0 && (
                <InfoCards
                  section={infoCardSection}
                  openModalForm={openModalFormInquiry}
                />
              )}
              {reviewsData[0].hasReviews ? (
                <Reviews
                  ref={reviewsSectionRef}
                  sections={reviewsData}
                  t={t}
                  openModalForm={openModalFormReview}
                />
              ) : (
                <SystemRightForMe
                  ref={reviewsSectionRef}
                  section={doYouKnow}
                  openModalForm={openModalFormReview}
                  dark
                />
              )}
            </>
          )}
        </div>
        {!isPaid && (
          <div className="bg-primary-25">
            {reviewsData[0].hasReviews ? (
              <Reviews
                ref={reviewsSectionRef}
                sections={reviewsData}
                t={t}
                openModalForm={openModalFormReview}
              />
            ) : (
              <SystemRightForMe
                ref={reviewsSectionRef}
                section={doYouKnow}
                dark
                topHalfColor={colors.primary[50]}
                bottomHalfColor={colors.primary[25]}
                openModalForm={openModalFormReview}
              />
            )}
            {/* <Alternatives ref={alternativesRef} section={alternatives} /> */}
            <SystemRightForMe
              section={companyCheck}
              topHalfColor={colors.primary[25]}
              bottomHalfColor="white"
              link={companyCheck.componentData.buttonHref}
            />
          </div>
        )}
        <PopularCategories
          section={popularSection}
          t={t}
          showAllCategoriesLink={false}
        />
        <AccordionSection
          ref={accordionSectionRef}
          section={accordionData}
          t={t}
        />
        <SystemRightForMe
          section={systemRightForMe}
          topHalfColor={!isPaid && 'white'}
          bottomHalfColor={!isPaid && colors.primary[50]}
          link={systemRightForMe.componentData.buttonHref}
          disabled={preview}
        />
        {isPaid && aboutSection.componentData.description.length > 0 && (
          <AboutSystem section={aboutSection} />
        )}
        {compareSection.componentData.length > 0 && (
          <CompareSystems ref={compareRef} section={compareSection} />
        )}
      </main>
      <Footer data={footer} siteUrls={siteUrls} preview={preview} />
      {modalOpenInquiry && (
        <ServiceRequestModal
          data={serviceRequestData.componentData}
          isOpen={modalOpenInquiry}
          onClose={closeModalForm}
          t={t}
        />
      )}

      {modalOpenReview && (
        <ModalContainer
          header={writeReviewData.header}
          onClose={closeModalForm}
          t={t}
        >
          {writeReviewData?.renderBusinesswithReviewForm({ closeModalForm })}
        </ModalContainer>
      )}
    </div>
  );
};

System.propTypes = {};
